import { ValidationError, ValueError } from "../exceptions";
import t                               from "@/i18n/translator";

export default class BaseField {
    constructor({ label, validators = [], helpText, required = true, zeroValues = [] }) {
        this._prevents = [];
        this.zeroValues = zeroValues;
        this.required = required;
        this.validators = [this.validate.bind(this), ...validators];
        this.errorMessages = [];
        this.helpText = helpText;
        this.label = label;
        this.prevent(
            label === undefined,
            "`label` parameter is required",
        );
        this.runPrevents();
    }

    toJS(val) {
        return val;
    }

    validate(val) {
        if (this.zeroValues.indexOf(val) !== -1 && this.required) {
            throw new ValidationError(t("required"));
        }
    }

    runValidators(val) {
        this.validators.forEach(f => {
            try {
                f(val);
            } catch (e) {
                if (e instanceof ValidationError) {
                    this.errorMessages.push(e.toString());
                } else {
                    throw e;
                }
            }
        });

        return this.errorMessages;
    }

    nonZero(val) {
        return this.zeroValues.indexOf(val) === -1;
    }

    clean(val) {
        val = this.toJS(val);
        if (!this.required && !val) return;
        return this.runValidators(val);
    }

    prevent(condition, exceptionMessage) {
        this._prevents.push([condition, exceptionMessage]);
    }

    runPrevents() {
        this._prevents.forEach(prevent => {
            if (prevent[0]) {
                throw new ValueError(prevent[1]);
            }
        });
    }

    get hasErrors() {
        return this.errorMessages.length > 0;
    }

    get errors() {
        return this.errorMessages;
    }
}
